import { useState } from 'react'

import { AddButton } from '#app/routes/mocra+/_form+/components/add-button.tsx'
import { FacilityOverlay } from '#app/routes/mocra+/_form+/components/facilities/overlay.tsx'
import {
	createFacilityDraft,
	type FacilityDraft,
} from '#app/routes/mocra+/_form+/components/facilities/types.ts'

type Props = {
	readonly onSubmit: (draft: FacilityDraft) => void
	readonly defaultValue?: FacilityDraft
	readonly triggerLabel?: string
	readonly disabled?: boolean
	readonly className?: string
}

export function FacilityAdd({
	onSubmit,
	defaultValue,
	triggerLabel,
	disabled,
	className,
}: Props) {
	const [open, setOpen] = useState(false)

	const handleSubmit = (draft: FacilityDraft) => {
		onSubmit(draft)
		setOpen(false)
	}

	return (
		<>
			<AddButton
				onClick={() => setOpen(true)}
				disabled={disabled}
				className={className}
			>
				{triggerLabel ?? 'Add facility'}
			</AddButton>
			<FacilityOverlay
				mode="add"
				open={open}
				onOpenChange={setOpen}
				onSubmit={handleSubmit}
				initialValue={defaultValue ?? createFacilityDraft()}
				onClosed={() => setOpen(false)}
			/>
		</>
	)
}
